module.exports = __webpack_public_path__ + "img/meetup-conference-cam.png";


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/quiz_type/result/img/meetup-conference-cam.png
// module id = 93
// module chunks = 0